import React, { useEffect, useRef, useState } from "react";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import _ from "lodash";
import socket from "../../../../socket";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { api } from "../../../../Apis/interceptor";
import moment from "moment";
import {
  checkUnreadMessages,
  getMessages,
  saveImage,
  saveMessage,
  updateUnreadMessages,
} from "../../../../Services/messageService";
import { Twemoji } from "react-emoji-render";
import { verifyToken } from "../../../../Services/authService";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import { getOppAccess } from "../../../../Services/opportunityService";
import Avatar from "react-avatar";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";

const TeamChat = () => {
  const [openChatBox, setOpenChatBox] = useState(false);
  const [noOppUsers, setNoOppUsers] = useState([]);
  const [otherUsers, setOtherUsers] = useState([]);
  const [otherUsersList, setOtherUsersList] = useState("");
  const [message, setMessage] = useState("");
  const [fileName, setFileName] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [endUser, setEnduser] = useState("");
  const [image, setImage] = useState([]);
  const [sortedKeys, setSortedKeys] = useState([]);
  const [messageHistory, setMessageHistory] = useState([]);
  const [typingUsers, setTypingUsers] = useState([]);
  const { globalOpportunityData } = useOpportunity();
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [unReadMsg, setUnReadMsg] = useState(false);
  const [msgBG, setMsgBG] = useState("");
  const opportunityData = useRef();
  const messageEndRef = useRef(null);
  const typingUsersRef = useRef([]);
  const emojiPickerRef = useRef(null);
  const navigate = useNavigate()
  opportunityData.current = globalOpportunityData;

  const openChat = () => {
    chatMessage();
    setOpenChatBox(!openChatBox);
  };
  const closeChatMessage = () => {
    setOpenChatBox(false);
  };

  const scrollToBottom = () => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [messageHistory]);

  useEffect(() => {
    const enduser = localStorage.getItem("enduser");
    if (enduser) {
      var user = JSON.parse(enduser)
      setCustomerId(user.customer);
      setEnduser(user);
    }
  }, [globalOpportunityData]);

  useEffect(() => {
    if (customerId && globalOpportunityData) {
      checkUnreadMessage();
    }
  }, [customerId]);

  const chatMessage = () => {
    if (_.isEmpty(messageHistory)) {
      socket.emit("loadMessages", {
        customer_id: customerId,
        opportunity_id: globalOpportunityData._id,
      });
    } else {
      var triggerScrollBottom = _.cloneDeep(messageHistory);
      setMessageHistory(triggerScrollBottom);
    }
    setTimeout(()=>{
      setShowPanel(!showPanel)
      setUnReadMsg(false)
      localStorage.setItem("isGroupMsg",false)
      localStorage.setItem("isPersonalMsg",false)
    },0)
  };


  const removeFile = (index) => {
    setImage((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  useEffect(()=>{
    if(_.isUndefined(localStorage.getItem("isGroupMsg")) ){
      localStorage.setItem("isGroupMsg", false)
    }else if(!localStorage.getItem("isGroupMsg")){
      setUnReadMsg(false)
    }else{
      setMsgBG("p-badge-success")
      setUnReadMsg(true)

    }
    if (_.isUndefined(localStorage.getItem("isPersonalMsg"))) {
      localStorage.setItem("isPersonalMsg", false)
  } else if(localStorage.getItem("isPersonalMsg") == true){
      setMsgBG("p-badge-danger")
      setUnReadMsg(true)
  }
  },[])

  useEffect(() => {
    socket.on("reloadMessages", async (data) => {
      const enduser = localStorage.getItem("enduser");
      if(enduser){
        var user = JSON.parse(enduser)
        if (user && user.customer && opportunityData && opportunityData.current) {
          if (opportunityData.current._id === data.opportunity_id) {
            const getMessagesResponse = await getMessages(
              user.customer,
              opportunityData.current._id
            );
            if (getMessagesResponse && getMessagesResponse.data.success) {
              var keys = Object.keys(getMessagesResponse.data.groupedMsgs);
              const sortedKeys = keys.sort(function (left, right) {
                return moment(left, "DD-MM-YYYY").diff(
                  moment(right, "DD-MM-YYYY")
                );
              });
              let updatedMessageHistory = getMessagesResponse.data.groupedMsgs;
  
              sortedKeys.forEach((key) => {
                updatedMessageHistory[key] = updatedMessageHistory[key].map(
                  (message) => ({
                    ...message,
  
                    isRight: message.sentBy_id === user.userid,
                    uniq_color: randColor(),
                  })
                );
              });
              setMessageHistory(updatedMessageHistory);
              setSortedKeys(sortedKeys);
              const updateUnreadMessagesResponse = await updateUnreadMessages(
                user.customer,
                user,
                opportunityData.current._id
              );
            }
            if (!_.isUndefined(data.message)) {
              if (!showPanel) {
                setUnReadMsg(true);
                if (data.message.indexOf(user.username) != -1) {
                  localStorage.setItem("isPersonalMsg", true);
                  setMsgBG("p-badge-danger");
                } else if (msgBG !== "label-danger") {
                  localStorage.setItem("isGroupMsg", true);
                  setMsgBG("p-badge-success");
                }
              }
            }
          }
        }
      }else {
        navigate("/login")
        localStorage.clear()
      }
    });
    return () => {
      socket.off("reloadMessages");
    };
  }, []);

  useEffect(() => {
    randColor();
  }, []);

  const randColor = () => {
    const max = 1 << 24;
    return "#" + (max + Math.floor(Math.random() * max)).toString(16).slice(-6);
  };
  const typingMsg = () => {
    socket.emit("typingMsg", {
      username: endUser.username,
      customer_id: customerId,
      opportunity_id: globalOpportunityData._id,
    });
    setTimeout(() => {
      socket.emit("notTyping", {
        username: endUser.username,
        customer_id: customerId,
        opportunity_id: globalOpportunityData._id,
      });
    }, 500);
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showEmojiPicker]); 
  useEffect(() => {
    const handlePushUsername = (data) => {
      if (
        opportunityData.current._id === data.opportunity_id &&
        data.username !== endUser.username
      ) {
        if (!typingUsersRef.current.includes(data.username)) {
          typingUsersRef.current.push(data.username);  
          setTypingUsers([...typingUsersRef.current]);  
        }
      }
    };
    socket.on("pushUsername", handlePushUsername);
    return () => {
      socket.off("pushUsername", handlePushUsername);
    };
  }, [opportunityData, endUser.username, socket]);

  useEffect(() => {
    const handleRemoveUsername = (data) => {
      if (
        opportunityData.current._id === data.opportunity_id &&
        data.username !== endUser.username
      ) {
        const index = typingUsersRef.current.indexOf(data.username);
        if (index !== -1) {
          typingUsersRef.current.splice(index, 1);  
          setTypingUsers([...typingUsersRef.current]);  
        }
      }
    };
    socket.on("removeUsername", handleRemoveUsername);
    return () => {
      socket.off("removeUsername", handleRemoveUsername);
    };
  }, [opportunityData, endUser.username, socket]);

  const checkUnreadMessage = async () => {
    const checkUnreadMessagesResponse = await checkUnreadMessages(
      customerId,
      endUser,
      globalOpportunityData._id
    );
    if (checkUnreadMessagesResponse && checkUnreadMessagesResponse.status === 200) {
      if (checkUnreadMessagesResponse && checkUnreadMessagesResponse.data.length > 0) {
        chatMessage();
      }
    }
  };

  const handleEmojiSelect = (emoji) => {
    setMessage(message + emoji.native);
  };

  const handleFileChange = (e) => {
    // setImage(e.target.files[0]);
    const files = Array.from(e.target.files); // Convert files object to array
    setImage((prevFiles) => [...prevFiles, ...files]);
  };
  const saveMessages = async (fileName) => {
    const saveMessageResponse = await saveMessage(
      customerId,
      endUser,
      globalOpportunityData._id,
      message,
      fileName
    );
    if (saveMessageResponse.data.success) {
      let messageHistoryCopy = messageHistory;
      if (messageHistoryCopy.length > 0) {
        messageHistoryCopy[0].isRepeated = false;

        if (
          saveMessageResponse.data.sentBy_id ===
          messageHistoryCopy[messageHistoryCopy.length - 1].sentBy_id
        ) {
          saveMessageResponse.data.message.isRepeated = true;
        } else {
          saveMessageResponse.data.message.isRepeated = false;
        }
      } else {
        saveMessageResponse.data.message.isRepeated = false;
      }
      if (saveMessageResponse.data.message.sentBy_id === endUser.userid) {
        saveMessageResponse.data.message.isRight = true;
      } else {
        saveMessageResponse.data.message.isRight = false;
      }
      var sentDate = moment(
        saveMessageResponse.data.message.sent_date,
        "DD-MM-YYYY h mm a"
      ).format("DD-MM-YYYY");
      if (messageHistoryCopy[sentDate]) {
        messageHistoryCopy[sentDate].push(saveMessageResponse.data.message);
      } else {
        messageHistoryCopy[sentDate] = [];
        messageHistoryCopy[sentDate].push(saveMessageResponse.data.message);
        var keys = Object.keys(messageHistoryCopy);
        const sortedKeys = keys.sort(function (left, right) {
          return moment(left, "DD-MM-YYYY").diff(moment(right, "DD-MM-YYYY"));
        });
        setSortedKeys(sortedKeys);
      }
      var msgList = _.cloneDeep(messageHistoryCopy);
      setMessageHistory(msgList);

      socket.emit("newMessage", {
        customer_id: customerId,
        opportunity_id: globalOpportunityData._id,
        message: message,
      });
      setMessage("");
      setFileName("");
    }
  };
  const dateFormatter = (date) => {
    return moment(date, "DD-MM-YYYY").calendar(null, {
      sameDay: "[Today]",
      lastDay: "[Yesterday]",
      lastWeek: "[Last] dddd",
      sameElse: "DD MMM,YYYY",
    });
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        sendChatMessage();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [image,message]);

  const sendChatMessage = async () => {
    if (image.length > 0) {
      image.forEach(async (file) => {
        const uploadImageApiResponse = await api.post(
          `api/v1/uploadImage/${customerId}`,
          { file: file, customer_id: customerId },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (uploadImageApiResponse.data.error_code === 0) {
          setFileName(file.name);
          setImage([]);
          saveMessages(uploadImageApiResponse.data.fileName);
        }
      });
    } else {
      if (!_.isEmpty(message)) {
        saveMessages();
      }
    }
  };
  const imageDownload = async (image) => {
    var isTokenValid = await verifyToken();
    if(isTokenValid.success){
      const saveImageResponse = saveImage(image);
    }
  };
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const getImageUrl = (imageName) => {
    if (!imageName) return null;
    return `${backendUrl}/public/assets/img/chat/${imageName}`;
  };
  const getOppStatus = async () => {
    if (globalOpportunityData && endUser) {
      const getOppAccessResponse = await getOppAccess(globalOpportunityData._id, endUser.userid)
      if (getOppAccessResponse && getOppAccessResponse.data.access) {
        const accessResp = getOppAccessResponse.data;

        if (accessResp.access && accessResp.user.length !== 0) {
          let tmpOppUsers = [];
          let otherUsers = [];
          const uniqUsers = _.uniqBy(accessResp.user, "userId");

          if (uniqUsers.length > 2) {
            tmpOppUsers.push({
              initial: `${uniqUsers[0].firstname[0]}${uniqUsers[0].lastname[0]}`,
              name: `${uniqUsers[0].firstname} ${uniqUsers[0].lastname}`,
              color: "#fc5c7d",
            });
            tmpOppUsers.push({
              initial: `${uniqUsers[1].firstname[0]}${uniqUsers[1].lastname[0]}`,
              name: `${uniqUsers[1].firstname} ${uniqUsers[1].lastname}`,
              color: "#00aa9c",
            });

            for (let i = 2; i < uniqUsers.length; i++) {
              otherUsers.push(`${uniqUsers[i].firstname} ${uniqUsers[i].lastname}`);
            }
            setOtherUsers(otherUsers)

            setOtherUsersList(otherUsers.join(", "));
          } else {
            if (uniqUsers.length === 1) {
              tmpOppUsers[0] = {
                initial: `${uniqUsers[0].firstname[0]}${uniqUsers[0].lastname[0]}`,
                name: `${uniqUsers[0].firstname} ${uniqUsers[0].lastname}`,
                color: "#fc5c7d",
              };
            } else if (uniqUsers.length === 2) {
              tmpOppUsers[0] = {
                initial: `${uniqUsers[0].firstname[0]}${uniqUsers[0].lastname[0]}`,
                name: `${uniqUsers[0].firstname} ${uniqUsers[0].lastname}`,
                color: "#fc5c7d",
              };
              tmpOppUsers[1] = {
                initial: `${uniqUsers[1].firstname[0]}${uniqUsers[1].lastname[0]}`,
                name: `${uniqUsers[1].firstname} ${uniqUsers[1].lastname}`,
                color: "#00aa9c",
              };
            }
          }
          setNoOppUsers(tmpOppUsers);
        }
      }
    }

  };
  useEffect(() => {
    getOppStatus()
  }, [endUser])

  return (
    <>
      <div>
        <div className="who-is-editing-section">
          <div className="flex justify-content-between align-content-center">
           
            <ButtonElement
              type="button"
              badge={unReadMsg? "New" :""} 
              badgeClassName={msgBG}
              className="cancel-new-button editing-icon clear-filter ml-20"
              icon="pi pi-comment"
              onClick={openChat}
            />

          
          </div>

        </div>
        {openChatBox && (
          <div className="chat-box-adjustment">
            <div className="w-100 bg-white chatbox">
              <div className="flex justify-content-between align-items-center mar-16 chat">
                <div className="flex justify-content-between align-items-center gap-2">
                  <i className="pi pi-users icon-font"></i>
                  <p className="m-auto ml-2 font-bold">Chat with Team</p>
                  
                </div>
                <div className="flex">
                <div>
            <div >
              {noOppUsers.length <= 2 && otherUsers.length === 0 && (
                <div>
                  {noOppUsers.map((user, index) => (
                    <span
                      key={index}
                      className="col-md-1 col-sm-1 col-xs-1 img-responsive"

                    >
                      <Avatar
                        name={user.name || "NA"}
                        color={user.color || "#000"}
                        fgColor="white"
                        round={true}
                        size="40"
                        className="avatar-img"
                      />
                      <Tooltip id={`tooltip-${index}`} className="pointer" place="right" />
                    </span>
                  ))}
                </div>
              )}

              {otherUsers.length > 0 && (
                <div>
                  {noOppUsers.map((user, index) => (
                    <span
                      key={index}
                      className="col-md-1 col-sm-1 col-xs-1 img-responsive"

                    >
                      <Avatar
                        name={user.initial || "NA"}
                        color={user.color || "#000"}
                        fgColor="white"
                        round={true}
                        size="40"
                        className="avatar-img"
                      />
                      <Tooltip id={`tooltip-${index}`} place="right" />
                    </span>
                  ))}
                  <span
                    className="tooltip-span"
                    data-tooltip-id="other-users-tooltip"
                    data-tooltip-content={otherUsersList}
                  >
                    and {otherUsers.length} more
                  </span>
                  <Tooltip id="other-users-tooltip" className="pointer" place="top" />
                </div>
              )}
            </div>
          </div>
                <ButtonElement
                  type="button"
                  className="cancel-new-button clear-filter"
                  icon="pi pi-times"
                  onClick={closeChatMessage}
                />
                </div>
              </div>
              <div className="mar-16 h-75 overflow-auto">
                <div className="scrollable-div">
                  {sortedKeys?.map((key, keyIndex) => (
                    <div key={keyIndex}>
                      {messageHistory[key]?.map((message, messageIndex) => (
                        <React.Fragment key={messageIndex}>
                          {messageIndex === 0 && (
                            <div className="text-center">
                              <label className="form-label text-left font-bold">{dateFormatter(key)}</label>
                              {/* <h4 className="chat-date-cover">
                                <span className="chat-date">
                                  {dateFormatter(key)}
                                </span>
                              </h4> */}
                            </div>
                          )}

                          {message.isRight ? (
                            <div className="flex justify-content-end">
                              <div className="sender">
                                <div>
                                  {!message.isRight &&
                                    messageHistory[key][messageIndex - 1]
                                      ?.sentBy_id !== message.sentBy_id && (
                                      <label className="form-label text-left">
                                        {message.sentBy_name}
                                      </label>
                                    )}
                                  <div className="form-label text-left">
                                    {message.message.text && (
                                      <Twemoji
                                        children={message.message.text}
                                      />
                                    )}
                                  </div>

                                  {message.message.image && (
                                    <div>
                                      {message.message.image.endsWith(
                                        ".xlsx"
                                      ) ? (
                                        <div className="chat-message-file">
                                          <a
                                            href={getImageUrl(
                                              message.message.image
                                            )}
                                            download
                                            className="chat-file-link"
                                          >
                                            <i className="pi pi-file-excel" />{" "}
                                            {message.message.image}
                                          </a>
                                          <ButtonElement
                                            icon="pi pi-download"
                                            onClick={() =>
                                              imageDownload(
                                                message.message.image
                                              )
                                            }
                                            className="cancel-new-button border-none bg-transparent chat-file-download"
                                          />
                                        </div>
                                      ) : (
                                        <div className="chat-message-image">
                                          <img
                                            src={getImageUrl(
                                              message.message.image
                                            )}
                                            alt="uploaded"
                                            className="uploaded-image"
                                          />
                                          <ButtonElement
                                            icon="pi pi-download"
                                            onClick={() =>
                                              imageDownload(
                                                message.message.image
                                              )
                                            }
                                            className="cancel-new-button border-none bg-transparent chat-image-download"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div
                                    style={{
                                      textAlign: "right",
                                      fontSize: "10px",
                                    }}
                                    className="message-time"
                                    title={`${dateFormatter(key)} at ${message.sent_time
                                      }`}
                                  >
                                    {new Date(
                                      message.utc_time
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="flex">
                              <div className="receiver">
                                <div>
                                  {!message.isRight &&
                                    messageHistory[key][messageIndex - 1]
                                      ?.sentBy_id !== message.sentBy_id && (
                                      <label className="form-label text-left">
                                        <b>{message.sentBy_name}</b>
                                      </label>
                                    )}
                                  <div className="form-label text-left">
                                    {message.message.text && (
                                      <Twemoji
                                        children={message.message.text}
                                      />
                                    )}
                                  </div>
                                  {message.message.image && (
                                    <div>
                                      {message.message.image.endsWith(
                                        ".xlsx"
                                      ) ? (
                                        <div className="chat-message-file">
                                          <a
                                            href={getImageUrl(
                                              message.message.image
                                            )}
                                            download
                                            className="chat-file-link"
                                          >
                                            <i className="pi pi-file-excel" />{" "}
                                            {message.message.image}
                                          </a>
                                          <ButtonElement
                                            icon="pi pi-download"
                                            onClick={() =>
                                              imageDownload(
                                                message.message.image
                                              )
                                            }
                                            className="cancel-new-button border-none bg-transparent chat-file-download"
                                          />
                                        </div>
                                      ) : (
                                        <div className="chat-message-image">
                                          <img
                                            src={getImageUrl(
                                              message.message.image
                                            )}
                                            alt="uploaded"
                                            className="uploaded-image"
                                          />
                                          <ButtonElement
                                            icon="pi pi-download"
                                            onClick={() =>
                                              imageDownload(
                                                message.message.image
                                              )
                                            }
                                            className="cancel-new-button border-none bg-transparent chat-image-download"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div
                                    style={{
                                      textAlign: "left",
                                      fontSize: "10px",
                                    }}
                                    className="message-time"
                                    title={`${dateFormatter(key)} at ${message.sent_time
                                      }`}
                                  >
                                    {new Date(
                                      message.utc_time
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {messageIndex === messageHistory[key].length - 1 && (
                            <div className="row">&nbsp;</div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                  <div ref={messageEndRef} />
                </div>

              </div>
              {image && image.length > 0 && (
                <div className="uploaded-files">
                  {image &&
                    image.map((file, index) => (
                      <div key={index} className="uploaded-file">
                        {file.type.startsWith("image/") ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt="uploaded"
                            width="100"
                            height="100"
                          />
                        ) : (
                          <a
                            href={URL.createObjectURL(file)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {file.name}
                          </a>
                        )}
                        <div className="h-100">
                          <ButtonElement
                            type="button"
                            icon="pi pi-times"
                            onClick={() => removeFile(index)}
                            className="cancel-new-button border-none bg-transparent"
                          />
                        </div>
                      </div>
                    ))}
                </div>
              )}
              <div className="flex align-items-center gap-2">
                <div className="w-100">
                  <div className="flex justify-content-between align-items-center gap-1">
                    <div className="flex flex-column w-100">
                      {typingUsers && typingUsers?.length > 0 && (
                        <span className="form-label text-left pl-16">{typingUsers?.join(", ") + " typing..."}</span>
                      )}
                      <InputTextElementElement
                        type="text"
                        className="form-control message-input-box mr-2 w-full fs-13"
                        name="messages"
                        value={message}
                        onChange={(e) => {
                          setMessage(e.target.value);
                          typingMsg();
                        }}
                        placeholder="Type a message..."
                      />
                    </div>
                    <div className="d-flex">
                      <label
                        htmlFor="file-upload"
                        className="pi pi-paperclip m-auto file-upload pointer"
                      >
                        <input
                          id="file-upload"
                          type="file"
                          accept="image/*"
                          name="image"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                      </label>

                      <ButtonElement
                        type="button"
                        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        className="cancel-new-button emoji-button border-none"
                      >
                        😀
                      </ButtonElement>

                      {showEmojiPicker && (
                        <div className="emoji-style" ref={emojiPickerRef}>
                          <Picker data={data} onEmojiSelect={handleEmojiSelect} />
                        </div>
                      )}
                      <ButtonElement
                        type="button"
                        className="cancel-new-button send-button clear-filter"
                        icon="pi pi-send"
                        onClick={sendChatMessage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TeamChat;
